module.exports = __webpack_public_path__ + "as.svg?23e6ae7d55de1077626007fdfe9a5822";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/as.svg
// module id = 975
// module chunks = 0